import {useEffect, useState, useRef} from "react";
import {
    Alert,
    AlertTitle,
    Select,
    MenuItem,
    // FilledInput,
    Card,
    Typography,
    Grid,
    Input,
    Link,
    Button,
} from "@mui/material";
import {FileInput} from "@deere/fuel-react/FileInput";
import {FileList} from '@deere/fuel-react/FileList';
import {FileListItem} from '@deere/fuel-react/FileListItem';
import {FileValidationList} from '@deere/fuel-react/FileValidationList';
import {FileValidationListItem} from '@deere/fuel-react/FileValidationListItem';
import {useOktaAuth} from "@okta/okta-react";
// import { InfoOutlined } from "@material-ui/icons";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {IconButton} from "@mui/material";
import SubmitAs2 from "../utils/modal-as2-confirmation";
import SupplierSelectComponent from "../../supplier-select-component/SupplierSelectComponent";

import {useClient, useAs2Client} from "../hooks/useClient";
import {
    setCaCertificateData,
    setTrustedCertificateData,
    setMailboxData,
    setMailboxRawData,
    setAs2PartnerData,
    setRelationshipData,
    setRoutingRuleData,
    setCodeListData,
    setMailData,
    setRoutingRuleRawData,
    setContractData,
} from "../utils/postJsons";

const NewAs2TradingRelationship = (props) => {
    const {usertype, userEmail} = props;
    const [supplierName, setSupplierName] = useState(null);
    const [supplierNumber, setSupplierNumber] = useState("");
    const [supplierList, setSupplierList] = useState([]);
    const [profileName, setProfileName] = useState("");
    const [partnerIdentifier, setPartnerIdentifier] = useState("");
    const [ipAdress, setIpAdress] = useState("");
    const [successSubmit, setSuccessSubbmit] = useState(false);
    const [caCertificateText, setCaCertificateText] = useState("");
    const [exchangeCertificateText, setExchangeCertificateText] = useState("");
    const [caCertificateName, setCaCertificateName] = useState("");
    const [exchangeCertificateName, setExchangeCertificateName] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [certAlert, setCerAlert] = useState(false);
    const [emptyFieldAlert, setEmptyFieldAlert] = useState(false);
    const [as2TpAlert, setAs2TpAlert] = useState(false);
    const [as2TpVerification, setAs2TpVerification] = useState({});
    const [adapterFlag, setAdapterFlag] = useState(false);
    const [encryptionAlgo, setEncryptionAlgo] = useState("0");
    const [signingAlgo, setSigningAlgo] = useState("5");
    const [invalidCAFileType, setInvalidCAFileType] = useState();
    const [invalidExSignFileType, setInvalidExSignFileType] = useState();
    const [caCertificateExists, setCaCertificateExists] = useState(false);
    const {oktaAuth} = useOktaAuth();
    const client = useClient(oktaAuth.getAccessToken());
    const as2Client = useAs2Client(oktaAuth.getAccessToken());
    const caCerRef = useRef();
    const exSignCerRef = useRef();


    const validateCACert = (file, cerType) => {
        const isValidExtension = file.name.endsWith('.cer') || file.name.endsWith('.der');
        setInvalidCAFileType(!isValidExtension);
        if (isValidExtension) {
            extractFile(file, cerType);
            certName(cerType);
        }
    };
    const validateExSignCert = (file, cerType) => {
        const isValidExtension = file.name.endsWith('.cer') || file.name.endsWith('.der');
        setInvalidExSignFileType(!isValidExtension);
        if (isValidExtension) {
            extractFile(file, cerType);
            certName(cerType);
        }
    };

    useEffect(() => {
        const data = window.localStorage.getItem("HTTP_CLIENT_ADAPTER");
        if (data != null) setAdapterFlag(JSON.parse(data));
    }, []);

    useEffect(() => {
        window.localStorage.setItem("HTP_CLIENT_ADAPTER", JSON.stringify(adapterFlag));
    }, [adapterFlag]);

    useEffect(() => {
        checkFields();
    }, [profileName, partnerIdentifier, ipAdress]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [showAlert, certAlert, emptyFieldAlert, as2TpAlert]);

    useEffect(() => {
        console.log(caCertificateExists)
    }, [caCertificateExists]);

    const handleKeyDown = async (e) => {
        //for John Deere internal Employee, needs to submit atleast 4 digits
        try {
            if (e.target.value.length >= 3) {
                const response = await client.get(
                    process.env.REACT_APP_API_BASE_URL +
                    "/getSupplierInfoEmployee?queryString=" +
                    e.target.value
                );
                const filteredResponse = response.data.map(
                    (item) => item.supplierNumber + " - " + item.supplierName
                );
                setSupplierList(filteredResponse);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const supplierChangeHandler = (event) => {
        setSupplierNumber(event.slice(0, 10));
        setSupplierName(event.slice(13));
    };

    const checkFields = () => {
        if (
            profileName.length > 0 &&
            partnerIdentifier.length > 0 &&
            ipAdress.length > 0
        )
            setSuccessSubbmit(true);
        else setSuccessSubbmit(false);
    };

    const displayInfoAlert = () => {
        setShowAlert((current) => !current);
    };

    const downnloadIpRanges = async () => {
        if (process.env.REACT_APP_ENV_CONNECTION_INFO === "DEVL_CONNECTION_INFO") {
            try {
                const element = document.createElement("a");
                const devlConnectionInfo = await import(
                    "../../../assets/zip/DEVL_CONNECTION_INFO.zip"
                    );
                element.href = devlConnectionInfo.default;
                element.download = "DEVL_CONNECTION_INFO.zip";
                document.body.appendChild(element);
                element.click();
            } catch (error) {
                console.log("error");
            }
        } else if (
            process.env.REACT_APP_ENV_CONNECTION_INFO === "PROD_CONNECTION_INFO"
        ) {
            try {
                const element = document.createElement("a");
                const devlConnectionInfo = await import(
                    "../../../assets/zip/PROD_CONNECTION_INFO.zip"
                    );
                element.href = devlConnectionInfo.default;
                element.download = "PROD_CONNECTION_INFO.zip";
                document.body.appendChild(element);
                element.click();
            } catch (error) {
                console.log("error");
            }
        }
    };

    const isCertificateDuplicated = async (type, name) => {
        try {
            const response = await client.get(
                `B2BAPIs/svc/digitalcertificateduplicatechecks/?_range=0-999&certType=${type}&certName=${name}`
            );
            return response.data[0].exists.code;
        } catch (error) {
            console.log(error);
            return 400;
        }
    };

    const sendMail = async () => {
        try {
            const response = await client.post(
                "scs/rcs/email",
                setMailData(userEmail, partnerIdentifier)
            );
            return response.status;
        } catch (error) {
            return 400;
        }
    };

    const createCertificate = async (type) => {
        if (type === "CA") {
            try {
                const response = await client.post(
                    "B2BAPIs/svc/cadigitalcertificates/",
                    setCaCertificateData(caCertificateText, caCertificateName)
                );
                //console.log(response.status)
                //console.log(response.data)
                return response.status;
            } catch (error) {
                return 400;
            }
        }
        if (type === "trusted") {
            try {
                const response = await client.post(
                    "B2BAPIs/svc/trusteddigitalcertificates/",
                    setTrustedCertificateData(
                        exchangeCertificateText,
                        exchangeCertificateName
                    )
                );
                console.log("Trusted creation: ", response.status);
                return response.status;
            } catch (error) {
                return 400;
            }
        }
        return 404;
    };

    const extractFile = (file, type) => {
        try {
            const reader = new FileReader();
            reader.readAsText(file);
            reader.onload = () => {
                if (reader.result) {
                    let text = reader.result;
                    //remove break lines
                    text = text.replace(/(\r\n|\n|\r)/gm, "");
                    text = text
                        .split("-----BEGIN CERTIFICATE-----")[1]
                        .split("-----END CERTIFICATE-----")[0];
                    switch (type) {
                        case "trusted":
                            setExchangeCertificateText(text);
                            setEmptyFieldAlert(false);
                            break;
                        case "CA":
                            setCaCertificateText(text);
                            setEmptyFieldAlert(false);
                            break;
                    }
                }
            };
        } catch (error) {
            console.log(error);
        }
    };

    const certName = (type) => {
        if (ipAdress.length > 1) {
            let certName = ipAdress.split("/");
            certName = certName[2].split(":")[0];
            certName = `${certName}_${type}`;

            //console.log(certName)

            switch (type) {
                case "trusted":
                    setExchangeCertificateName(certName);
                    setEmptyFieldAlert(false);
                    break;
                case "CA":
                    setCaCertificateName(certName);
                    setEmptyFieldAlert(false);
                    break;
            }
        } else {
            setEmptyFieldAlert(true);
        }
    };

    const as2PartnerExists = async () => {
        try {
            const response = await client.get(
                `B2BAPIs/svc/as2tradingpartners/?_range=0-999&as2Identifier=${partnerIdentifier}`
            );
            const responseData = response.data;
            let match = false;

            if (responseData.length === 0) {
                return match;
            }

            if (responseData.length > 0) {
                responseData.map((tps) => {
                    if (tps.as2Identifier === partnerIdentifier) {
                        match = true;
                    }
                });
            }
            return match;
        } catch (error) {
            return 400;
        }
    };

    const createAs2Tp = async () => {
        try {
            const response = await client.post(
                "B2BAPIs/svc/as2tradingpartners/",
                setAs2PartnerData(
                    partnerIdentifier,
                    caCertificateName,
                    exchangeCertificateName,
                    ipAdress,
                    profileName,
                    adapterFlag,
                    encryptionAlgo,
                    signingAlgo,
                    caCertificateExists
                )
            );

            const as2Id = decodeURIComponent(response.data.Location.split("/")[6]);
            return as2Id;
        } catch (error) {
            return 400;
        }
    };

    const verifyMailbox = async () => {
        try {
            const response = await client.get(
                `B2BAPIs/svc/mailboxes/?_range=0-999&path=%2Fapp_data%2FB2Bi%2Fmailbox%2FEDI_${profileName}`
            );
            if (response.data.length === 0) {
                return {duplicate: false, id: ""};
            }

            let match = false;
            let mailboxId = "";

            if (response.data.length > 0) {
                const data = response.data;

                data.map((mailbox) => {
                    const mailboxPath = mailbox.path;
                    const mailboxSplited = mailboxPath.split("/");
                    const mailboxName = mailboxSplited[4];
                    if (mailboxName === `EDI_${profileName}`) {
                        match = true;
                        mailboxId = mailbox._id;
                    }
                });
                return {duplicate: match, id: mailboxId};
            }
            return response.status;
        } catch (error) {
            return {status: 400, msg: "API error"};
        }
    };

    const createNewMailbox = async () => {
        try {
            const mailboxVerification = await verifyMailbox();

            if (!mailboxVerification.duplicate) {
                const response = await client.post(
                    "B2BAPIs/svc/mailboxes/",
                    setMailboxData(profileName)
                );
                const id = response.data.Location.split("/")[6];
                return id;
            } else {
                return mailboxVerification.id;
            }
        } catch (error) {
            return 400;
        }
    };

    const createRawMailbox = async (type) => {
        try {
            const response = await client.post(
                "B2BAPIs/svc/mailboxes/",
                setMailboxRawData(profileName, type)
            );
            createRoutingRule(type);
            return response.status;
        } catch (error) {
            return 400;
        }
    };

    const createAs2Relationship = async (as2TpId, mailboxId) => {
        try {
            const response = await client.post(
                "B2BAPIs/svc/as2tradingrelationships/",
                setRelationshipData(as2TpId, mailboxId)
            );
            await createRoutingRule("Inbound");
            await insertCrossRef();
            await updateWorkflowContract(as2TpId);
            return response.status;
        } catch (error) {
            return 400;
        }
    };

    const createRoutingRule = async (type) => {
        if (type === "Inbound") {
            try {
                const response = await as2Client.post(
                    "api/routing-rule/add-mailbox",
                    setRoutingRuleData(profileName, type)
                );
                return response.status;
            } catch (error) {
                return 400;
            }
        } else {
            try {
                const response = await client.post(
                    "api/routing-rule/add-mailbox",
                    setRoutingRuleRawData(profileName, type)
                );
                return response.status;
            } catch (error) {
                return 400;
            }
        }
    };

    const insertCrossRef = async () => {
        as2Client
            .post(
                "api/code-list/add-item",
                setCodeListData(partnerIdentifier, supplierNumber)
            )
            .catch((error) => {
                console.log(error.errorDescription);
            });
    };

    const updateWorkflowContract = async (consumerId) => {
        const contractData = setContractData(consumerId);
        try {
            const response = await as2Client.put(
                "api/as2/contract/update-workflow",
                contractData
            );
            return response.status;
        } catch (error) {
            return 400;
        }
    };

    const createAs2TradingPartner = async () => {
        try {
            if(caCertificateExists){
                const caCertificateVerification = await isCertificateDuplicated("CA", caCertificateName);
                if (caCertificateVerification) {
                    setCerAlert(true);
                    return {
                        verification: false,
                        msg: "The CA Certificate already exists.\n Please try another one",
                    };
                }
            }
            const trustedCertificateVerification = await isCertificateDuplicated(
                "trusted",
                exchangeCertificateName
            );

             if (trustedCertificateVerification) {
                setCerAlert(true);
                return {
                    verification: false,
                    msg: "The trusted Certificate already exists.\n Please try another one",
                };
            } else {
                setCerAlert(false);
            }

            const idVerification = await as2PartnerExists();

            if (idVerification) {
                setAs2TpAlert(true);
                return {
                    verification: false,
                    msg: "The AS2 ID already exists.\n Please try another one",
                };
            } else {
                setAs2TpAlert(false);
            }
            const mailboxId = await createNewMailbox();

            if (mailboxId === 400) {
                return {
                    verification: false,
                    msg: "Error in the Mailbox Creation.\n Wait a moment and try again",
                };
            }
            if(caCertificateExists){
                const caCertificateCreation = await createCertificate("CA");
                if (caCertificateCreation === 400) {
                    return {
                        verification: false,
                        msg: "Error in the Creation of the CA Certificate Creation.\n Wait a minute and try again",
                    };
                }
            }

            const trustedCertificateCreation = await createCertificate("trusted");

            if (trustedCertificateCreation === 400) {
                return {
                    verification: false,
                    msg: "Error in the Creation of the exchange Certificate Creation.\n Contact EDI team to delete it",
                };
            }

            const as2TpId = await createAs2Tp();

            if (as2TpId === 400 || as2TpId.length === 0) {
                return {
                    verification: false,
                    msg: "Error in the Creation of the AS2 Trading Partner.\n Wait a minute and try again",
                };
            }

            const updatingCertsName = await changeCertName();

            if (updatingCertsName === 400) {
                return {
                    verification: false,
                    msg: "The Certificates already exists.\n Please try another ones",
                };
            }

            const checkRelationshipStatus = await createAs2Relationship(
                as2TpId,
                mailboxId
            );

            if (checkRelationshipStatus === 400) {
                return {
                    verification: false,
                    msg: "Error in the Creation of the Relationship.\n Contact EDI team",
                };
            }

            const checkRawInbound = await createRawMailbox("RAW_I");
            const checkRawOutbound = await createRawMailbox("RAW_O");

            if (checkRawInbound >= 400 || checkRawOutbound >= 400) {
                return {
                    verification: false,
                    msg: "Error in the Raw Mailboxes Creation.\n Contact EDI team to create them",
                };
            }

            const checkMailWasSended = await sendMail();

            if (checkMailWasSended === 400) {
                return {
                    verification: true,
                    msg: "Error while sending mail.\n But the process was correct",
                };
            }

            setAdapterFlag((current) => !current);

            return {
                verification: true,
                msg: " A new AS2 Trading Relationship has been created without errors!",
            };
        } catch (error) {
            return {verification: false, msg: "Error in the API"};
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const verifyProcess = await createAs2TradingPartner();
        console.log(certAlert)
        setAs2TpVerification(verifyProcess);
    };

    const getCertificatesExpirationDate = async () => {
        try {
            const response = await client.get(
                `B2BAPIs/svc/as2tradingpartners/?_range=0-999&as2Identifier=${partnerIdentifier}`
            );

            if (response.data.length === 1) {
                const responseData = response.data[0];
                return {
                    caExpDate: responseData.caCertificate[0].notAfterDate,
                    exchangeExpDate: responseData.exchangeCertificate[0].notAfterDate,
                };
            }

            if (response.data.length > 1) {
                const responseData = response.data;

                responseData.map((partner) => {
                    if (partner === partnerIdentifier) {
                        return {
                            caExpDate: partner.caCertificate[0].notAfterDate,
                            exchangeExpDate: partner.exchangeCertificate[0].notAfterDate,
                        };
                    }
                });
            }

            return response.status;
        } catch (error) {
            return 400;
        }
    };

    const formatSuppName = () => {
        const splittedSuppName = supplierName.split(" ");

        if (splittedSuppName.length > 2) {
            return `${splittedSuppName[0]}_${splittedSuppName[1]}_${splittedSuppName[2]}`;
        }
        return supplierName.replaceAll(" ", "_");
    };

    const formatExpiration = async () => {
        try {
            const certsExpirationDates = await getCertificatesExpirationDate();

            const caCertExpDate = certsExpirationDates.caExpDate.split("/");
            const formattedCaExpDate =
                caCertExpDate[2] + caCertExpDate[0] + caCertExpDate[1];

            const trustedCertExpDate = certsExpirationDates.caExpDate.split("/");
            const formattedTrustedExpDate =
                trustedCertExpDate[2] + trustedCertExpDate[0] + trustedCertExpDate[1];

            return {
                caExpirationDate: formattedCaExpDate,
                trustedExpirationDate: formattedTrustedExpDate,
            };
        } catch (error) {
            return 400;
        }
    };

    const changeCertName = async () => {
        try {
            const suppNumber = supplierNumber.replace(/(0)\1+/y, "");
            const suppName = formatSuppName();
            const expDates = await formatExpiration();

            const newCaCertName = `CA_${suppNumber}_${suppName}_${expDates.caExpirationDate}`;
            const newTrustedCertName = `trusted_${suppNumber}_${suppName}_${expDates.trustedExpirationDate}`;

            if(caCertificateExists) {
                const caCertVerification = await isCertificateDuplicated("CA", newCaCertName);
                if (caCertVerification) {
                    setCerAlert(true);
                    await client.delete(`B2BAPIs/svc/cadigitalcertificates/${caCertificateName}`);
                    return 400;
                }

                await client.put(`B2BAPIs/svc/cadigitalcertificates/${caCertificateName}`,
                    {
                        certName: `${newCaCertName}`,
                        verifyAuthChain: false,
                        verifyValidity: false,
                    }
                );
            }
            const trustedCertificateVerification = await isCertificateDuplicated(
                "trusted",
                newTrustedCertName
            );

            if (trustedCertificateVerification) {
                setCerAlert(true);
                await client.delete(
                    `B2BAPIs/svc/trusteddigitalcertificates/${exchangeCertificateName}`
                );
                return 400;
            }



            await client.put(
                `B2BAPIs/svc/trusteddigitalcertificates/${exchangeCertificateName}`,
                {
                    certName: `${newTrustedCertName}`,
                    verifyAuthChain: false,
                    verifyValidity: false,
                }
            );

            return 200;
        } catch (error) {
            return 400;
        }
    };

    return (
        <div>
            <Typography gutterBottom variant="h1" component="h1">
        <span className="cardcontain">
          AS2 Direct Connect | New AS2 Trading Relationship
        </span>
            </Typography>

            <Card className="p-4">
                <form onSubmit={handleSubmit}>
                    {showAlert ? (
                        <Alert
                            severity="info"
                            title="John Deere's AS2 IP Adress Range"
                            onClose={displayInfoAlert}
                        >
                            <Link onClick={downnloadIpRanges}>
                                View Partner Whitelist Firewall Rules
                            </Link>
                        </Alert>
                    ) : null}
                    {as2TpAlert ? (
                        <Alert
                            severity="error"
                        >
                            <AlertTitle>{'The AS2 Partner already exists. Check the AS2 Identifier'}</AlertTitle>
                            {"The AS2 Partner already exists. Check the AS2 Identifier"}</Alert>
                    ) : null}
                    {certAlert ? (
                        <Alert
                            severity="error"
                        ><AlertTitle>{"The Certificate already exists"}</AlertTitle></Alert>
                    ) : null}

                    <Grid container alignItems="flex-start" spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <h6 className="entryLabel">Supplier Number</h6>
                            <SupplierSelectComponent
                                userType={usertype}
                                supplierList={supplierList}
                                supplierChangeHandler={supplierChangeHandler}
                                handleKeyDown={handleKeyDown}
                            />
                        </Grid>
                    </Grid>

                    <Grid container alignItems="flex-start" spacing={4}>
                        <Grid item xs={6} sm={3}>
                            <h6 className="entryLabel">Partner's Identity/Profile Name</h6>
                            <Input
                                required
                                placeholder="Name"
                                id="profile-name"
                                value={profileName}
                                onChange={(e) =>
                                    setProfileName(e.target.value.toUpperCase().replace(" ", "_"))
                                }
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <h6 className="entryLabel">Encryption Algorithm</h6>
                            <Select
                                defaultValue={"0"}
                                id="encryption-algorithm"
                                onChange={(e) => setEncryptionAlgo(e.target.value)}
                            >
                                <MenuItem value="0">
                                    Triple DES 168 CBC with PKCS5 padding
                                </MenuItem>
                                <MenuItem value="1">56-bit DES CBC with PKCS5 padding</MenuItem>
                                <MenuItem value="2">
                                    128-bit RC2 CBC with PKCS5 padding
                                </MenuItem>
                                <MenuItem value="4">40-bit RC2 CBC with PKCS5 padding</MenuItem>
                                <MenuItem value="6">
                                    128-bit AES CBC with PKCS5 padding
                                </MenuItem>
                                <MenuItem value="8">
                                    256-bit AES CBC with PKCS5 padding
                                </MenuItem>
                            </Select>
                        </Grid>
                    </Grid>

                    <Grid container alignItems="flex-start" spacing={4}>
                        <Grid item xs={6} sm={3}>
                            <h6 className="entryLabel">Partner's AS2 Identifier</h6>
                            <Input
                                required
                                placeholder="Unique AS2 ID"
                                id="partner-identifier"
                                value={partnerIdentifier}
                                onChange={(e) =>
                                    setPartnerIdentifier(
                                        e.target.value.toUpperCase().replace(" ", "_")
                                    )
                                }
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <h6 className="entryLabel">Signing Algorithm</h6>
                            <Select
                                defaultValue="5"
                                id="signing-algorithm"
                                onChange={(e) => setSigningAlgo(e.target.value)}
                            >
                                <MenuItem value="0">MD5</MenuItem>
                                <MenuItem value="1">SHA1</MenuItem>
                                <MenuItem value="2">SHA256</MenuItem>
                                <MenuItem value="3">SHA384</MenuItem>
                                <MenuItem value="4">SHA512</MenuItem>
                                <MenuItem value="5">SHA-1</MenuItem>
                                <MenuItem value="6">SHA-256</MenuItem>
                                <MenuItem value="7">SHA-384</MenuItem>
                                <MenuItem value="8">SHA-512</MenuItem>
                            </Select>
                        </Grid>
                    </Grid>
                    <Grid container alignItems="flex-start" spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <h6 className="entryLabel">Partner's End Point IP/URL</h6>
                            <Input
                                required
                                placeholder="URL/IP Adress"
                                id="ip-adress"
                                value={ipAdress}
                                onChange={(e) => setIpAdress(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid container alignItems="flex-start" spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <p className="entryLabel">
                                CA Digital Certificate{" "}
                                <span className="textFormat">
                  (.cer or .der format required)
                </span>
                            </p>
                            <FileInput
                                id="ca-digital-certificate"
                                name="ca-digital-certificate"
                                ref={caCerRef}
                                inputProps={{accept: '.cer,.der'}}
                                onChange={(event) => {
                                    const files = event.target.files;
                                    if (files && files.length > 0) {
                                        setCaCertificateExists(true);
                                        validateCACert(files[0], "CA");
                                    }
                                    else{
                                        console.log("No file set. That's okay")
                                        setCaCertificateExists(false);
                                    }
                                }}
                                renderFileList={(fileList) => (
                                    <FileList>
                                        {fileList?.map((file) => (
                                            <FileListItem
                                                key={file.name}
                                                text={file.name}
                                                validationState={
                                                    invalidCAFileType ? 'invalid' : 'valid'
                                                }
                                            />
                                        ))}
                                    </FileList>
                                )}
                                renderValidations={() => (
                                    <>
                                        <Typography component="div" variant="labelMedium">
                                            File Format
                                        </Typography>
                                        <FileValidationList>
                                            <FileValidationListItem
                                                text="File Type (.cer, .der)"
                                                state={invalidCAFileType ? 'invalid' : 'valid'}
                                            />
                                        </FileValidationList>
                                    </>
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container alignItems="flex-start" spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <p className="entryLabel">
                                Exchange/Signing Certificate{" "}
                                <span className="textFormat">
                  (.cer or .der format required)
                </span>
                            </p>

                            <FileInput
                                id="ex-digital-certificate"
                                name="ex-digital-certificate"
                                ref={exSignCerRef}
                                inputProps={{accept: '.cer,.der'}}
                                onChange={(event) => {
                                    const files = event.target.files;
                                    if (files && files.length > 0) {
                                        validateExSignCert(files[0], "trusted");
                                    } else {
                                        certName(null);
                                    }
                                }}

                                renderFileList={(fileList) => (
                                    <FileList>
                                        {fileList?.map((file) => (
                                            <FileListItem
                                                key={file.name}
                                                text={file.name}
                                                validationState={
                                                    invalidExSignFileType ? 'invalid' : 'valid'
                                                }
                                            />
                                        ))}
                                    </FileList>
                                )}
                                renderValidations={() => (
                                    <>
                                        <Typography component="div" variant="labelMedium">
                                            File Format
                                        </Typography>
                                        <FileValidationList>
                                            <FileValidationListItem
                                                text="File Type (.cer, .der)"
                                                state={invalidExSignFileType ? 'invalid' : 'valid'}
                                            />
                                        </FileValidationList>
                                    </>
                                )}
                            />

                        </Grid>
                    </Grid>

                    <Grid container mt={5} alignItems="flex-start" spacing={4}>
                        <Grid item xs={6} sm={3}>
                            <SubmitAs2
                                controlSubmit={successSubmit}
                                as2Verification={as2TpVerification.verification}
                                message={as2TpVerification.msg}
                                update={false}
                            />
                        </Grid>

                        <Grid item xs={12} sm={"auto"}>
                            <Typography size="md" fontWeight="bold" component="p">
                                John Deere's AS2 IP Adress Range
                                <IconButton onClick={displayInfoAlert}>
                                    <fuel-icon name={"info"}/>
                                </IconButton>
                            </Typography>
                            <Typography
                                size="md"
                                fontWeight="regular"
                                component={"p"}
                                className="textFormat"
                            >
                                Partner Whitelist Firewall Rules
                                <IconButton aria-label="download" onClick={downnloadIpRanges}>
                                    <fuel-icon name={"download"}/>
                                </IconButton>
                            </Typography>
                        </Grid>
                    </Grid>
                </form>
            </Card>
        </div>
    );
};

export default NewAs2TradingRelationship;
